import './style.less'
import cn from 'classnames'

class FloatingPopup {
    constructor({popupContent, top, left, right, bottom, className}) {
        this.handleOverlayClick = this.handleOverlayClick.bind(this)

        this.popupElement = document.createElement('div')
        this.popupElement.className = cn("ui2-floating-popup", className)
        this.popupElement.innerHTML = popupContent
        this.popupElement.style.top = top
        this.popupElement.style.left = left
        this.popupElement.style.right = right
        this.popupElement.style.bottom = bottom

        this.closeOverlay = document.createElement('div')
        this.closeOverlay.className = 'ui2-floating-popup-close-overlay'
    }

    show() {
        this.closeOverlay.addEventListener('mousedown', this.handleOverlayClick)
        document.body.appendChild(this.closeOverlay)
        document.body.appendChild(this.popupElement)
    }

    destroy() {
        this.closeOverlay.removeEventListener('mousedown', this.handleOverlayClick)
        document.body.removeChild(this.closeOverlay)
        document.body.removeChild(this.popupElement)
    }

    handleOverlayClick(event) {
        this.destroy()
    }
}

export default FloatingPopup
